import "./StylePreviewItem.css";

interface ItemProps {
    title: string;
    price: string;
    imagePath: string;
}

export default function StylePreviewItem({ title, price, imagePath }: ItemProps) {
    return (
        <div className="style-preview-item-container">
            <h1>{title}</h1>
            <div className="image-container" style={{ backgroundImage: `url(${imagePath})` }}>
                <div className="price-container">
                    ${price}<span className="currency">CAD</span>
                </div>
                <div className="svg-container">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 28">
                        <path d="M10.6675 0H16.0012V27.6211H10.6675V0Z" />
                        <path d="M24.0018 4.7158L26.6686 9.38323L2.99553 23.1938L0.328662 18.5263L24.0018 4.7158Z" />
                        <path d="M2.66686 4.7158L0 9.38323L23.6731 23.1938L26.34 18.5263L2.66686 4.7158Z" />
                    </svg>
                </div>
            </div>
        </div>
    );
}